export default __webpack_public_path__ + "static/media/XiqBox.cd24c89f.svg";